angular.module('rjmNg.filters').filter "paginate", () ->
  (arr, page, limit) ->
    start = (page-1) * limit
    end = page * limit
    if arr
      return arr.slice(start,end)

    return null
